<template>
	<div class="mainBox">
		<div class="topNav">
			<van-nav-bar safe-area-inset-top :placeholder="true" :fixed="true" title="报验详情" left-text="返回" left-arrow
				@click-left="goBack">
			</van-nav-bar>
		</div>
		<div class="projectItem">
			<van-row gutter="10" class="notesTop">
				<van-col span="6">
					<div class="patrolLabel isBgDarkOrange">{{ record.majorName }}</div>
					<div class="patrolLabel isBgBlue">{{ record.categoryName }}</div>
				</van-col>
				<van-col span="18">
					<div class="patrolTitle">{{ record.subjectName }}</div>
				</van-col>
			</van-row>
			<div class="patrolTime">{{ record.testDate }} {{ record.testMan }}</div>
			<van-row gutter="20" style="margin-top: 10px;">
				<!-- <van-col span="24">
					<div class="problemDetailItem "><span>检验部件</span>{{ record.partsName }}</div>
				</van-col> -->
				<van-col span="24">
					<div class="problemDetailItem "><span>检验项目</span>{{ record.probContext }}</div>
				</van-col>
				<!-- <van-col span="12">
					<div class="problemDetailItem "><span>检验形式</span>{{ record.testTypeName }}</div>
				</van-col> -->
				<van-col span="24">
					<div class="problemDetailItem "><span>1次检验结论</span>{{ record.testConclusionName }}</div>
				</van-col>
				<van-col span="24">
					<div class="problemDetailItem "><span>2次检验结论</span>{{ record.testConclusionName2 }}</div>
				</van-col>
				<van-col span="24">
					<div class="problemDetailItem "><span>2次以上检验结论</span>{{ record.testConclusionName3 }}</div>
				</van-col>
				<van-col span="24">
					<div class="problemDetailItem"><span>检验意见</span>{{ record.sutContent }}</div>
				</van-col>
				<van-col span="12">
					<div class="problemDetailItem"><span>封闭人</span>{{ record.closeMan }}</div>
				</van-col>
				<van-col span="12">
					<div class="problemDetailItem"><span>封闭时间</span>{{ record.closeTime }}</div>
				</van-col>
				<!-- <van-col span="24">
					<div class="problemDetailItem"><span>现场照片</span></div>
				</van-col> -->
			</van-row>
			<!-- <van-row gutter="20" style="margin-top: 10px;">
				<van-col span="8" v-for="img in record.list" :key="img.photoId">
					<van-image width="2.5rem" height="2.5rem" fit="cover" :src="img.photoPathUri" />
				</van-col>
			</van-row> -->
		</div>
		<!-- <div class="projectItem" v-if="record.problem && record.problem.stateFlg == '1'">
			<van-row gutter="20">
				<van-col span="24" style="margin-left: 180px;">
					<div class="problemDetailItem "><span>封闭情况</span></div>
				</van-col>
				<van-col span="12">
					<div class="problemDetailItem "><span>封闭人</span>{{ record.closeMan }}</div>
				</van-col>
				<van-col span="12">
					<div class="problemDetailItem"><span>封闭时间</span>{{ record.closeTime }}</div>
				</van-col>
				<van-col span="24">
					<div class="problemDetailItem"><span>整改照片</span></div>
				</van-col>
			</van-row>
			<van-row gutter="20" style="margin-top: 10px;">
				<van-col span="8" v-for="img in record.problem.afterPhotoList" :key="img.photoId">
					<van-image width="2.5rem" height="2.5rem" fit="cover" :src="img.fileUri" />
				</van-col>
			</van-row>
		</div> -->
		<div class="projectItem">
			<div class="notesTop">
				整改前照片
			</div>
			<van-row gutter="20" style="margin-top: 10px;">
				<van-col span="8" v-for="(img, index) in record.scenePhotoList" :key="index">
					<van-image width="2.5rem" height="2.5rem" fit="cover" :src="img.fileUri" />
				</van-col>
			</van-row>
		</div>
		<div class="projectItem">
			<div class="notesTop">
				整改后照片
			</div>
			<van-row gutter="20" style="margin-top: 10px;">
				<van-col span="8" v-for="(img, index) in record.closePhotoList" :key="index">
					<van-image width="2.5rem" height="2.5rem" fit="cover" :src="img.fileUri" />
				</van-col>
			</van-row>
		</div>
	</div>
</template>
<script>
import { info } from '../../api/safeInspection'
import { Notify } from 'vant';
import common from '../../utils/common';

export default {
	name: 'safeInspectionDetail',
	data() {
		return {
			// 项目名称
			projectName: '',
			record: '',
			id: '',
		}
	},
	mounted() {
		this.project = common.getProject();
		if (this.project == null || this.project == undefined) {
			Notify({ type: 'danger', message: '获取项目信息失败' });
		}
		this.projectName = this.project.projectName
		this.id = this.$route.query.id;
		this.getDetail(this.id)

	},
	methods: {
		getSutConclusionName(id) {
			if (id == '0') {
				return '不合格';
			} else if (id == '1') {
				return '合格';
			} else {
				return '';
			}
		},
		getDetail(id) {
			info(id).then(response => {
				if (response.data.resultCode != 200) {
					Notify({ type: 'danger', message: response.data.resultMessage });
					return
				}
				this.record = response.data.body
			})
		},
		goBack() {
			this.$router.push({
				name: 'safeInspectionList'
			});
		}
	}
}
</script>
<style lang="scss" src="@/assets/sass/common.scss"></style>